import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SwiperCore from "swiper";

import { IAddressData, IAmphur, IProvince, IReward, IRewardUsed, ISubDistrict } from "@interfaces";
import { authApi, merchantApi, rewardApi } from "@api";
import { resetConfirm, selectAuth, selectMerchant, setLoading, setToggleConfirm } from "@redux";
import {
    ComponentPopUpAddress,
    ComponentPopUpConfirm,
    ComponentPopUpDone,
    ComponentRewardDetail,
    ComponentSelectType,
} from "@components";
import { enumStatus, enumTypes, enumValidation, PATH_HOME } from "@configs";
import { useNotify, RenderMeta, formatMessage } from "@utils";



const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",

};

export const PageReward = () => {
    //page hooks
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const { error, success, warning } = useNotify();
    const { t } = useTranslation();
    const history = useHistory();
    //redux state
    const { showConfirm, userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    const staticQuestion = merchant.signUpSettings?.staticQuestion;
    //page state
    const [reward, setReward] = useState<IReward>();
    const [rewardUsed, setRewardUsed] = useState<IRewardUsed>();
    const [count, setCount] = useState<number>(1);
    const [currentImage, setCurrentImage] = useState<number>(enumValidation.NUMBER_ONE);
    const [showSelectType, setShowSelectType] = useState<boolean>(false);
    const [variant, setVariant] = useState<string>("");
    const [showDone, setShowDone] = useState<boolean>(false);

    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);


    const [showAddress, setShowAddress] = useState<boolean>(false);

    useEffect(() => {
        fetchDetail();
    }, []);
    useEffect(() => {
        if (userInfo) {

            const firstFetchAddress = async () => {
                if (userInfo?.contact?.address) {
                    await getAmphur(parseInt(userInfo?.contact?.address?.province));
                    await getSubDistrictByamphur(parseInt(userInfo?.contact?.address?.district));

                    let disIndex = subDistrictList.findIndex(item => item?.district_id === userInfo?.contact?.address?.subDistrict);

                    let payload: IAddressData = {
                        address: userInfo?.contact?.address?.address,
                        province: userInfo?.contact?.address?.province,
                        district: userInfo?.contact?.address?.district,
                        // subDistrict: userInfo?.contact?.address?.subDistrict,
                        subDistrict: (disIndex !== -1 ? disIndex.toString() : "0"),
                        postCode: userInfo?.contact?.address?.postCode,
                    };
                    setAddressData(payload);
                };
            };
            firstFetchAddress();
        }
    }, [userInfo]);
    const fetchDetail = async () => {
        if (id) {
            dispatch(setLoading(true));
            try {
                const res = await rewardApi.getDetailById(id);
                const data = res.data as IReward;
                setReward(data);
                // if (data.point && userInfo?.totalPoints)
                //     setCount(data.point <= userInfo.totalPoints ? 1 : 0);
            } catch (err: any) {
                if (err.response) {
                    error(formatMessage(err.response));
                } else error(t("message.error"));
                history.goBack();
            } finally {
                dispatch(setLoading(false));
            }
        }
    };

    useEffect(() => {
        getAllProvince();
        dispatch(resetConfirm());
    }, []);

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100
        });
        setSubDistrictList(subRes.data.result);
        let newAdd = addressData;
        newAdd.province = subRes.data.result[0]?.province_id || "";
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };
    const onChangeSubDistrict = (value: any) => {
        let outSub = subDistrictList[value];
        setAddressData({
            ...addressData,
            subDistrict: value,
            postCode: outSub?.zipcode,
        });
    };
    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };

    const confirmAddress = async () => {
        let outSubDisIndex = 0;
        if (addressData?.subDistrict !== "") {
            outSubDisIndex = parseInt(addressData.subDistrict);
        };
        let proObj = provinceList.find(item => item?.province_id === addressData?.province);
        let disObj = amphurList.find(item => item?.amphur_id === addressData.district);
        let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
        let fullAdd = [addressData?.address,
        proObj?.province_name_tha,
        disObj?.amphur_name_tha,
        subObj?.district_name_tha,
        addressData.postCode
        ].join(" ");
        let addressPayload: any = {
            address: {
                ...addressData,
                subDistrict: (addressData.subDistrict !== "" ? subDistrictList[outSubDisIndex]?.district_id : ""),
                // subDistrict: subDistrictList[subDis].district_id
            },
            fullAddress: fullAdd,
        };
        let ResAdd = await authApi.saveQuestionSignUp(addressPayload);
        setShowAddress(false);
        dispatch(resetConfirm());
        success(t("page.address_success"));
        handleUseReward();

    };

    const handleAddCount = () => {
        if (reward) {
            if (
                userInfo?.totalPoints &&
                reward.point &&
                +userInfo?.totalPoints - handleCalculatePoint() > reward?.point
            ) {
                let maxCount = Infinity;
                if (reward.limit || reward.quantity) {
                    maxCount = Math.min(
                        reward.limit ? reward.limit : Infinity,
                        reward.quantity ? reward.quantity : Infinity
                    );
                }
                if (count < maxCount) {
                    setCount(count + 1);
                }
            } else {
                warning(t("page.do_not_have_enough_points"));
            }
        }
    };
    const handleMinusCount = () => {
        if (count > 1) {
            setCount(count - 1);
        }
    };

    const handleCalculatePoint = () => {
        if (reward && reward.point) {
            return reward.point * count;
        } else {
            return 0;
        }
    };

    const handleCheckAddress = () => {
        if (reward?.isDelivery) {
            setShowAddress(true);
            dispatch(setToggleConfirm());
        } else {
            handleUseReward();
        }
    };

    const handleUseReward = async () => {
        if (reward) {

            try {
                let proObj = provinceList.find(item => item?.province_id === addressData.province);
                let disObj = amphurList.find(item => item?.amphur_id === addressData.district);
                let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
                let addDisplay = {
                    province: proObj?.province_name_tha || "",
                    district: disObj?.amphur_name_tha || "",
                    subDistrict: subObj?.district_name_tha || "",
                };
                let shipText = [
                    addressData?.address,
                    addDisplay?.province,
                    addDisplay?.district,
                    addDisplay?.subDistrict,
                    addressData?.postCode
                ].join(" ");

                const res = await rewardApi.redeemed({
                    objectId: reward._id || "",
                    quantity: count || 1,
                    status: enumStatus.ACTIVE,
                    type: enumTypes.REWARD,
                    variants: [variant],
                    shippingAddress: (reward?.isDelivery ? shipText : ""),
                });
                setRewardUsed(res.data.reward);
                if (res) {
                    success(formatMessage(res));
                }
                await fetchDetail();
                // setShowDone(true);
                history.push(PATH_HOME);
            } catch (err: any) {
                if (err.response) {
                    error(formatMessage(err.response));
                } else {
                    error(t("message.use_coupon.fail"));
                }
                // history.push(PATH_HOME);
            }
        }
    };

    const handleChangeImage = (swiper: SwiperCore) => {
        setCurrentImage(swiper.realIndex + 1);
    };

    const handleChangeVariant = (value: string) => {
        setVariant(value);
        setShowSelectType(false);
    };

    const handleToggleConfirm = () => {
        dispatch(setToggleConfirm());
    };

    const handleToggleShowSelectType = () => {
        setShowSelectType(!showSelectType);
    };

    const handleClosePopupDone = () => {
        setShowDone(false);
        history.push(PATH_HOME);
    };

    const pointLeft = () => {
        if (userInfo?.totalPoints && reward?.point && userInfo.totalPoints >= reward.point) {
            return userInfo.totalPoints - reward?.point * count;
        } else return 0;
    };

    return (
        <>
            <RenderMeta title={t("meta.reward_detail", { name: reward?.name })} />
            {reward && !showSelectType && (
                <ComponentRewardDetail
                    pointLeft={pointLeft()}
                    handleAddCount={handleAddCount}
                    handleMinusCount={handleMinusCount}
                    count={count}
                    data={reward}
                    handleToggleConfirm={handleToggleConfirm}
                    currentImage={currentImage}
                    handleChangeImage={handleChangeImage}
                    handleToggleShowSelectType={handleToggleShowSelectType}
                    variant={variant}
                    variants={reward?.variants || []}
                />
            )}
            {showConfirm && reward && (
                <ComponentPopUpConfirm
                    handleCloseDetail={handleToggleConfirm}
                    data={{ ...reward, count } as IReward}
                    // handleConfirm={handleUseReward}
                    handleConfirm={handleCheckAddress}
                    handleCalculatePoint={handleCalculatePoint}
                    quantity={count}
                    cNote=""
                />
            )}
            {showDone && reward && (
                <ComponentPopUpDone
                    handleCloseDetail={handleClosePopupDone}
                    data={{ ...reward, count } as IReward}
                    usedData={rewardUsed}
                    handleCalculatePoint={handleCalculatePoint}
                    cNote=""
                />
            )}
            {showSelectType && reward && (
                <ComponentSelectType
                    variant={variant}
                    variants={reward?.variants || []}
                    handleChangeVariant={handleChangeVariant}
                    handleToggleShowSelectType={handleToggleShowSelectType}
                />
            )}

            {showAddress && <ComponentPopUpAddress
                showAddress={showAddress}
                handleCloseDetail={() => setShowAddress(false)}
                addressData={addressData}
                setAddressData={setAddressData}
                provinceList={provinceList}
                amphurList={amphurList}
                subDistrictList={subDistrictList}
                onChangeProvince={onChangeProvince}
                onChangeAmphur={onChangeAmphur}
                onChangeSubDistrict={onChangeSubDistrict}
                setAddressText={setAddressText}
                confirmAddress={confirmAddress}
            />
            }

        </>
    );
};
